import e from "react";
import { getIconColor as r } from "./iconfont.es5470.js";
import f from "./iconfont.es5471.js";
const d = {
  display: "block"
}, h = ({ size: a = 16, useVw: o, useRem: n, color: c, withColor: l, removeClassName: t, disableSSR: p, style: i, ...m }) => {
  const x = i ? { ...d, ...i } : d;
  return /* @__PURE__ */ e.createElement(f, { disableSSR: p }, /* @__PURE__ */ e.createElement("svg", { "data-icon-id": "24px-qianbao", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 24 24", width: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), height: o ? ((a || 0) / 375 * 100).toFixed(5) + "vw" : a + (n ? "rem" : "px"), className: t ? "" : "iconpark-icon", style: x, fill: "none", ...m }, /* @__PURE__ */ e.createElement(
    "g",
    {
      className: t ? "" : "24px-é±å"
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        className: t ? "" : "normal",
        d: "M5.11 2.622a2.986 2.986 0 0 0-2.941 2.473.799.799 0 0 0-.044.262V17.74a3.591 3.591 0 0 0 3.591 3.591h12.568a3.591 3.591 0 0 0 3.591-3.591v-7.157a3.591 3.591 0 0 0-3.591-3.591H17.9V5.516a2.894 2.894 0 0 0-2.893-2.894H5.11ZM3.725 17.74V8.252c.414.217.885.34 1.385.34h13.174c1.1 0 1.991.891 1.991 1.991v1.176h-3.99a2.685 2.685 0 0 0 0 5.37h3.99v.61c0 1.1-.892 1.992-1.991 1.992H5.716a1.99 1.99 0 0 1-1.991-1.991ZM5.11 6.992H16.3V5.516c0-.715-.579-1.294-1.293-1.294H5.11a1.385 1.385 0 0 0 0 2.77Zm10.09 7.452c0-.599.486-1.085 1.085-1.085h3.99v2.17h-3.99c-.6 0-1.085-.485-1.085-1.085Z",
        fillRule: "evenodd",
        fill: l ? r(c, 0, "#262933") : "#262933",
        datafollowfill: l ? r(c, 0, "#262933") : "#262933"
      }
    )
  )));
}, H = h;
export {
  H as default
};
